const capitalize = phrase => phrase.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());

export const getUserAddress = ({ feedback }) => {
  return (
    feedback.user_id?.verifiedAddress?.city &&
    `${capitalize(feedback.user_id?.verifiedAddress?.city)}, ${feedback.user_id?.verifiedAddress?.state}`
  );
};
